import script from "./ChatIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatIcon.vue?vue&type=script&setup=true&lang=js"

import "./ChatIcon.vue?vue&type=style&index=0&id=0f06844e&scoped=true&lang=css"

import exportComponent from "C:\\Source\\Tms\\TmsUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f06844e"]])

export default __exports__